import { Api } from 'src/core/decorators/dto/api.decorator';
import { DtoHasApi } from '../shared/dto-has-api.model';
import { GenericLookupDto } from '../generic-lookup/generic-lookup.dto';
import { CAUserDto } from '../administration/user/CAUser.dto';

@Api('api/app/feedback')
export class FeedbackDto extends DtoHasApi {
  agentId: string;
  feedback: string;
  sourceId: number;
  statusId: number;
  creationTime?: Date;
  status?: GenericLookupDto;
  source?: GenericLookupDto;
  agent?: CAUserDto;
  creator?: CAUserDto;
}
